export const BRAND_NAME = 'Bigshow777';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN = 'bigshow777.com';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN_SKIN_URL = 'bigshow777.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'mnto9.com';
